import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Dashboard from "../../common/components/layout/Dashboard";
import { TableInventoryVehicles } from "./components/TableInventoryVehicles";

const InventoryVehiclesPage = () => {
  return (
    <ToastProvider>
      <Dashboard>
        <TableInventoryVehicles />
      </Dashboard>
      <Toast />
    </ToastProvider>
  );
};

export default InventoryVehiclesPage;
